import React from "react";
import MapLeaflet from "../../../../components/Map";
import localeText from "../../../../locale";

const StoresMap = ({ plan }) => {
  return (
    <div id="StoresMap">
      <h3 style={{ paddingLeft: "7px" }}>{localeText("StoresMap")}</h3>
      <MapLeaflet style={{ height: "79dvh" }} />
    </div>
  );
};

export default StoresMap;
